import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Divider } from "semantic-ui-react";
import LoadResolver from "components/LoadResolver";
import { toast } from "../Toast/Toast";
import { getPrintSizes } from "store/selectors";
import { PrintSizeForm } from "forms/PrintSize";
import { PrintSizesTable } from "../PrintSizesTable/PrintSizesTable";

export const PrintSizeEditor = ({ dispatch, t }) => {
  const [isPrintSizeFormOpen, setIsPrintSizeFormOpen] = useState(false);
  const [printSizeToUpdate, setPrintSizeToUpdate] = useState(null);

  useEffect(() => {
    dispatch.printSizes.load();
  }, []);

  const printSizes = useSelector(getPrintSizes);

  const handlePrintSizeFormClose = () => {
    setIsPrintSizeFormOpen(false);
    setPrintSizeToUpdate(null);
  };

  const handleUpdate = (printSizeToUpdate) => {
    setPrintSizeToUpdate(printSizeToUpdate);
    setIsPrintSizeFormOpen(true);
  };

  const handleDelete = async (printSizeToDelete) => {
    try {
      await dispatch.printSizes.delete(printSizeToDelete);
      toast(undefined, t("print_size_delete_success"));
    } catch (error) {
      console.error(error);
      toast("error", t("print_size_delete_failure"));
    }
  };

  return (
    <LoadResolver isLoading={printSizes.isLoading} error={printSizes.error}>
      <div className="page-container">
        <h2>{t("print_sizes")}</h2>
        {isPrintSizeFormOpen ? (
          <PrintSizeForm
            printSizes={printSizes.items}
            printSizeToUpdate={printSizeToUpdate}
            closePrintSizeForm={handlePrintSizeFormClose}
            dispatch={dispatch}
            t={t}
          />
        ) : (
          <Button primary onClick={() => setIsPrintSizeFormOpen(true)}>
            {t("create_new")}
          </Button>
        )}
        <Divider />
        <PrintSizesTable
          items={printSizes.items}
          setPrintSizeToUpdate={setPrintSizeToUpdate}
          handleUpdate={handleUpdate}
          handleDelete={handleDelete}
          t={t}
        />
      </div>
    </LoadResolver>
  );
};
